export const externalRepairFields = [
  {
    label: "ส่งที่",
    name: "vendor",
    type: "text",
    required: true,
  },
  {
    label: "วันที่ส่งบริษัทนอก",
    name: "sentDate",
    type: "date",
    required: true,
  },
  {
    label: "รายละเอียดการดำเนินงาน",
    name: "details",
    type: "textarea",
    required: false,
  },
  {
    label: "หมายเหตุ",
    name: "notes",
    type: "textarea",
    required: false,
  },
  {
    label: "สถานะ",
    name: "repairStatus",
    type: "select",
    required: true,
    options: ["อยู่ระหว่างดำเนินการ", "เสร็จสิ้น", "ยกเลิก"],
  },
];
